import { ProjectConfigService } from './../../../model/services/api-services/project-config.service';
import { ProjectSaveDialogService } from './project-save-dialog.service';
import { ProjectConfig } from './../../../types/project-config';
import { ProjectConfigUtil, ConfigOptions } from './../../../model/project-config-util';
import { ModalMessagerService } from './../modal-messager/modal-messager.service';
import { SimpleHandler, TypedHandler } from './../../../types/handlers';
import { SubscriptionMgr } from './../../../model/SubscriptionMgr';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Project } from 'app/model/project';

export type ProjectHandler = (project: Project) => void;
export type PrjSaveMessage = 'exported' | 'saved';

export type ProjectSaveParams = ConfigOptions & {
  handler: TypedHandler<PrjSaveMessage>;
}


@Component({
  selector: 'app-project-save-entry',
  templateUrl: './project-save-entry.component.html',
  styleUrls: ['./project-save-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectSaveEntryComponent implements OnInit {
  private _updateHandler?: TypedHandler<PrjSaveMessage>;
  private projectConfig?: ProjectConfig;

  public exportGeneral = true;
  public exportAtts = true;
  public exportPresets = true;
  public exportSupplemental = true;
  public projectId?:any;
  constructor(public modal: NgbActiveModal,
    private messager: ModalMessagerService,
    private cdr: ChangeDetectorRef,
    private cfgSvc: ProjectConfigService) { }
  ngOnInit(): void {
  }
  Show(params: ProjectSaveParams) {
    this._updateHandler = params.handler;
    this.exportGeneral = (params.general === undefined) ? true : params.general;
    this.exportAtts = (params.attributes === undefined) ? true : params.attributes;
    this.exportPresets = (params.presets === undefined) ? true : params.presets;
    this.exportSupplemental = (params.supplemental === undefined) ? true : params.supplemental;
    this.projectConfig = params.config;
    this.projectId = params.project_id;
    this.cdr.detectChanges();
  }
  Hide() {
    this.modal.close();
  }
  SubmitConfig() {
    const params: ConfigOptions = {
      general:this.exportGeneral,
      attributes: this.exportAtts,
      presets: this.exportPresets,
      supplemental: this.exportSupplemental,
      config:this.projectConfig,
      project_id:this.projectId
    }

    this.cfgSvc.SaveConfig(params).then((data: any) => {
      if (data.response) data = data.response;
      if (data.status === 'ok') {
        // ToDo submit to server
        if (this._updateHandler) {
          this._updateHandler('saved');
        }
        this.messager.Notify('Your changes were saved to the server', false, 'Project Configuration Saved');
        return;
      }
      throw Error(data.message);
    }).catch((reason: string) => {
      this.messager.Notify('There was a problem saving to the server', true, 'Save error');
    });

  }
  SaveFile() {
    this.cdr.detectChanges();
    const params: ConfigOptions = {
      attributes: this.exportAtts,
      presets: this.exportPresets,
      supplemental: this.exportSupplemental,
      config: this.projectConfig
    }
    this.messager.RequestExport({
      extension: 'riscfg',
      contents: ProjectConfigUtil.EncodeConfig(params),
      mimeType: 'text/plain',
      defaultFileName: (params.config && params.config.general && params.config.general.name) ?
        params.config.general.name : 'project config'
    }, 'Exporting project configuration', (result: any) => {
      if (!!this._updateHandler) {
        this._updateHandler('exported');
      }
    });
  }
  UpdateCB(which: EventTarget | null) {
    if (!which) return;
    const id = (which as HTMLInputElement).getAttribute('id');
    const checked = (which as HTMLInputElement).checked;
    switch (id?.split('_').shift()) {
      case 'attributes':
        this.exportAtts = checked;
        break;
      case 'presets':
        this.exportPresets = checked;
        break;
      case 'suppl':
        this.exportSupplemental = checked;
        break;
    }
    this.cdr.detectChanges();
  }

}

